import { useRequiredPrepMillisecond } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanRequiredPrepMillisecond = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { requiredPrepMillisecondBeforeHour, requiredPrepMillisecondBeforeDate, requiredPrepMillisecond } = viewModel;

	return useRequiredPrepMillisecond({
		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		onSet: onSetViewModel,
	});
};
